query CourseBasicsQuery($handle: String!, $language: String!) {
  learnWorldsCourse(handle: $handle, language: $language) {
    created
    updated
    language
    handle
    courseID
    title
    description
    authorName
    authorImage
    courseImage
  }
}
